module.exports = __webpack_public_path__ + "static/media/tutorial5.fc37d131.mp4";